import Link from "next/link";
import type { BreadcrumbItem } from "@/lib/storefront-shell-types";

type StorefrontBreadcrumbsProps = {
  items: BreadcrumbItem[];
};

export function StorefrontBreadcrumbs({
  items,
}: StorefrontBreadcrumbsProps) {
  if (items.length === 0) {
    return null;
  }

  return (
    <nav aria-label="Breadcrumb" className="py-3">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs font-medium tracking-[0.12em] text-white/62 uppercase">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.path && !isLast ? (
                <Link
                  href={item.path}
                  className="transition-colors hover:text-white"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-white" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast ? <span className="text-white/28">/</span> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
